import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { CurrenciesService } from "src/app/api/currencies.service";
import { Currency } from "src/app/models/currency";
import { ThemeService } from "src/app/services/theme.service";

@Component({
    selector: "start-steps",
    templateUrl: "./start-steps.component.html",
    styleUrls: ["./start-steps.component.scss"],
    standalone: false
})
export class StartStepsComponent implements OnInit {
  theme$ = this.themeService.themeChanges.pipe(map((it) => it));
  public currencies$: Observable<Currency[]> =
    this.currenciesService.getCrypto();

  constructor(
    private themeService: ThemeService,
    private currenciesService: CurrenciesService
  ) {}

  ngOnInit() {}
}
